export default __webpack_public_path__ + "static/media/right_bg.4f418851.png";